// This file was automatically generated from print.immunizationHistory.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.immunizationHistory');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.ptImmunizations');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.immunizationHistory.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  if (opt_data.now) {
    el8.template.print.currentAsOf(opt_data, output);
  }
  output.append('<h1 class="documentTitle">Patient Immunization History</h1>');
  el8.template.print.patientInfo(opt_data, output);
  output.append('<table class="tableBordered tableCondensed mt10"><thead><tr><th>Vaccine</th><th>Dose 1</th><th>Dose 2</th><th>Dose 3</th><th>Dose 4</th><th>Dose 5</th><th>Dose 6</th></tr></thead><tbody>');
  var rowList13315 = opt_data.cdcSchedule.rows;
  var rowListLen13315 = rowList13315.length;
  for (var rowIndex13315 = 0; rowIndex13315 < rowListLen13315; rowIndex13315++) {
    var rowData13315 = rowList13315[rowIndex13315];
    output.append('<tr><td class="el8Cell1 el8Bold">', soy.$$escapeHtml(rowData13315.name), '</td>');
    var valueList13319 = rowData13315.values;
    var valueListLen13319 = valueList13319.length;
    for (var valueIndex13319 = 0; valueIndex13319 < valueListLen13319; valueIndex13319++) {
      var valueData13319 = valueList13319[valueIndex13319];
      output.append((valueIndex13319 == 0 && valueData13319.value == '') ? '<td class="el8Cell1 alignCenter">-</td>' : '<td class="el8Cell1">' + ((valueData13319.value == 'Declined on' || valueData13319.value == 'Has Immunity') ? '<p>' + soy.$$escapeHtml(valueData13319.value) + '</p>' : '') + ((valueData13319.date) ? '<p class="el8Bold">' + (soy.$$escapeHtml(valueData13319.date)? el8.service.tz.soyDate(soy.$$escapeHtml(valueData13319.date)) : '') + '</p>' : '') + ((valueData13319.description) ? '<p style="padding-bottom: 8px;">' + soy.$$escapeHtml(valueData13319.description) + '</p>' : (valueData13319.name) ? '<p>(' + soy.$$escapeHtml(valueData13319.name) + ')</p>' : '') + ((valueData13319.manufacturer) ? '<p><i>Manufacturer:</i> ' + soy.$$escapeHtml(valueData13319.manufacturer) + '</p>' : '') + ((valueData13319.lotNumber) ? '<p>#' + soy.$$escapeHtml(valueData13319.lotNumber) + '</p>' : '') + ((valueData13319.site) ? '<p><i>Site:</i> ' + soy.$$escapeHtml(valueData13319.site) + '</p>' : '') + ((valueData13319.vis) ? '<p><i>VIS:</i> ' + soy.$$escapeHtml(valueData13319.vis) + '</p>' : '') + ((valueData13319.physicianName) ? '<p><i>Admin\'d:</i> ' + soy.$$escapeHtml(valueData13319.physicianName) + '</p>' : '') + '</td>');
    }
    output.append('</tr>');
  }
  output.append('</tbody></table>');
  if (opt_data.otherImmunizations.length || opt_data.immHistoryItems.length) {
    output.append('<br><br><h4>Other Vaccines Documented:</h4><ul class="list">');
    var itemList13380 = opt_data.otherImmunizations;
    var itemListLen13380 = itemList13380.length;
    for (var itemIndex13380 = 0; itemIndex13380 < itemListLen13380; itemIndex13380++) {
      var itemData13380 = itemList13380[itemIndex13380];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptImmunizations.summary(itemData13380, output);
      output.append('</li>');
    }
    var itemList13385 = opt_data.immHistoryItems;
    var itemListLen13385 = itemList13385.length;
    for (var itemIndex13385 = 0; itemIndex13385 < itemListLen13385; itemIndex13385++) {
      var itemData13385 = itemList13385[itemIndex13385];
      output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(itemData13385.text), '</li>');
    }
    output.append('</ul>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
